import { device } from 'constants/media-query'
import styled from 'styled-components'

export const StyledSubscriptionsContainer = styled.div`
  :not(:first-child) {
    margin-bottom: 16px;
  }
  overflow: hidden;
`
export const StyledTabContentTitle = styled.h1`
  font-weight: 500;
  font-size: 20px;
  line-height: 24.2px;
  margin-top: 24px;
  margin-bottom: 32px;
  @media ${device.desktop} {
    display: none;
  }
`

export const StyledSubscriptionsMiniTitle = styled.h2`
  margin-top: 0;
  margin-bottom: 24px;
  font-weight: 600;
  font-size: 16px;
  line-height: 19.36px;
`
export const StyledSubscriptionsSwiperContainer = styled.div`
  margin-inline: 0px;
`

//swiper

export const StyledSubCardContainer = styled.div`
  position: relative;
  margin-bottom: 20px;
  height: 138px;
  padding-bottom: 6px;
  border-radius: 10px;
  background-color: rgba(204, 5, 33, 1);
`

//Card top part
export const StyledSubCardTopPart = styled.div`
  width: 100%;
  border-radius: 8px 8px 0 0;
  background-color: rgba(217, 217, 217, 1);
`
export const StyledSeasonSubTitle = styled.h2`
  padding: 6px;
  font-family: ${({ theme }) => theme.fonts.inter}, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 14.52px;
  text-align: center;
`

export const StyledWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-inline-end: 8px;
`
export const StyledContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`

export const StyledSubName = styled.span`
  padding: 0px;
  display: block;
  font-family: ${({ theme }) => theme.fonts.inter}, sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 16.94px;
  text-align: center;
`

//Card bottom part
export const StyledSubCardTBottomPartContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const StyledCustomerNumberSubTitle = styled.h2`
  padding-inline: 2px;
  font-size: 12px;
  margin-block: 7px;
  margin-bottom: 1px;
  margin-inline-start: 5px;
  padding-inline: 4px;
  font-weight: 700;
  line-height: 14.52px;
  text-align: right;
  color: rgba(255, 255, 255, 1);
`
export const StyledBottomPartSubTitle = styled.h2`
  padding-inline: 2px;
  font-size: 12px;
  margin-top: 0px;
  margin-bottom: 3px;
  margin-inline-start: 5px;
  padding-inline: 4px;
  font-weight: 700;
  line-height: 14.52px;
  text-align: right;
  color: rgba(255, 255, 255, 1);
`

export const StyledCardImg = styled.img`
  margin-inline-start: 10px;
  margin-block: 7px;
`
